// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResultRow-cls1__f8cc535f06af6ba4f598{/*!*/}.AutoCompleteResultRow-cls2___160d21a0346119a1f2c{display:flex;flex-direction:column;font-size:12px;width:calc(100% - 40px);padding-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResultRow-cls1__f8cc535f06af6ba4f598",
	"cls2": "AutoCompleteResultRow-cls2___160d21a0346119a1f2c AutoCompleteResultRow-cls1__f8cc535f06af6ba4f598"
};
export default ___CSS_LOADER_EXPORT___;
